module.exports = __webpack_public_path__ + "img/river-ml-simulation.ab6e8966.png";